// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_mb-0";
export var discountCodeInput = "_mb-1";